import React, { useMemo } from "react";
import MaterialTable from "material-table";
import moment from "moment";
import { Button } from "react-bootstrap";

export default function HeaderActionTable2({
  title,
  cols,
  rows,
  pageSize,
  search,
  pagin,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  interval,
  setInterval
}) {
  return (
    <div id={title.replace(/\s/g, "").toLowerCase()}>
      <MaterialTable
        columns={cols}
        data={useMemo(() => rows, [rows])}
        title={title}
        options={{
          exportButton: true,
          exportAllData: true,
          pageSize: pageSize ? pageSize : 1,
          paging: pagin === undefined ? true : false,
          search: search ? true : false,
          sorting: false,
          headerStyle: {
            backgroundColor: "#003459",
            color: "#FFF"
          }
        }}
        components={{
          Action: props => (
            <div
              style={{
                textAlign: "left",
                float: "left"
              }}
            >
              <Button
                style={{ margin: "2px 5px" }}
                variant={`${interval === "realtime" ? "outline-" : ""}dark`}
                onClick={() => {
                  setInterval("history");
                  setToDate(moment().subtract(1, "d").format("YYYY-MM-DD"));
                  setFromDate(moment().subtract(1, "d").format("YYYY-MM-DD"));
                }}
              >
                History
              </Button>
              <Button
                style={{ margin: "2px 5px" }}
                variant={`${interval === "history" ? "outline-" : ""}info`}
                onClick={() => {
                  setInterval("realtime");
                  setToDate(moment().format("YYYY-MM-DD"));
                  setFromDate(moment().format("YYYY-MM-DD"));
                }}
              >
                Realtime
              </Button>
              <input
                type="date"
                className="input"
                value={fromDate}
                max={
                  interval === "history"
                    ? moment().subtract(1, "d").format("YYYY-MM-DD")
                    : null
                }
                min={
                  interval === "realtime" ? moment().format("YYYY-MM-DD") : null
                }
                onChange={evt => setFromDate(evt.target.value)}
              />
              <input
                type="date"
                className="input"
                value={toDate}
                max={
                  interval === "history"
                    ? moment().subtract(1, "d").format("YYYY-MM-DD")
                    : null
                }
                min={
                  interval === "realtime" ? moment().format("YYYY-MM-DD") : null
                }
                onChange={evt => setToDate(evt.target.value)}
              />
            </div>
          )
        }}
        actions={[
          {
            onClick: (event, rowData) => alert("something "),
            isFreeAction: true
            // onClick: (event, rowData) => alert("You saved " + rowData.name),
          }
        ]}
        style={{ margin: "20px 10px 10px" }}
      />
    </div>
  );
}
